export const handleAllowedCharacters = (value: string, errorKey?: string) => {
  const allowedCharacters =
    "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789.!#$&'’*+-/?^_`{|}~@äöüßÄÖÜ"
  const allowedCharsRegex = new RegExp(`^[${allowedCharacters}]+$`)
  return errorKey ? allowedCharsRegex.test(value) || errorKey : allowedCharsRegex.test(value)
}
